import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadMediaPipe } from './load-media.pipe';
import { NoComma } from './no-comma.pipe';
import { NumberPipe } from './number.pipe';
import { CcyPipe } from './ccy.pipe';
import { SmartPricePipe } from './smart-price.pipe';
import { SortProjectsPipe } from './sort-projects.pipe';
import { ScreenLessThanPipe } from './screen-less-than.pipe';
import { YearsPipe } from './years.pipe';
import { OrderByPipe } from './order-by.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { BooleanOptionStatePipe } from './boolean-option-state.pipe';
import { SortOptionsByTypePipe } from './sort-options-by-type.pipe';
import { SortValues } from './sort-values.pipe';
import { PluralPipe } from './plural.pipe';
import { TextTransformPipe } from './text-transform.pipe';

@NgModule({
  declarations: [
    LoadMediaPipe,
    NoComma,
    NumberPipe,
    CcyPipe,
    SmartPricePipe,
    SortProjectsPipe,
    ScreenLessThanPipe,
    YearsPipe,
    OrderByPipe,
    SafeHtmlPipe,
    BooleanOptionStatePipe,
    SortOptionsByTypePipe,
    SortValues,
    PluralPipe,
    TextTransformPipe,
  ],
  imports: [CommonModule],
  exports: [
    LoadMediaPipe,
    NoComma,
    NumberPipe,
    CcyPipe,
    SmartPricePipe,
    SortProjectsPipe,
    ScreenLessThanPipe,
    YearsPipe,
    OrderByPipe,
    SafeHtmlPipe,
    BooleanOptionStatePipe,
    SortOptionsByTypePipe,
    SortValues,
    PluralPipe,
    TextTransformPipe,
  ],
})
export class PipesModule {}
